const API_BASE = import.meta.env.VITE_API_BASE ?? '';

async function req(method, path, body) {
  const opts = { method, headers: { 'Content-Type': 'application/json' } };
  if (body !== undefined) opts.body = JSON.stringify(body);
  const r = await fetch(`${API_BASE}${path}`, opts);
  const data = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(data.error ?? `Error ${r.status}`);
  return data;
}

export const crearEnsayo    = (sujeto)           => req('POST', '/api/ensayos', { sujeto });
export const getEnsayo      = (code)             => req('GET',  `/api/ensayos/${code}`);
export const guardarResultado = (code, tipo, registros) =>
  req('POST', `/api/ensayos/${code}/resultado`, { tipo, registros });

// ── Sesión local ──────────────────────────────────────────────────────────────
const KEY_CODE   = 'labpsi_ensayo_code';
const KEY_SUJETO = 'labpsi_ensayo_sujeto';

export function getSesionLocal() {
  const code   = sessionStorage.getItem(KEY_CODE);
  const sujeto = sessionStorage.getItem(KEY_SUJETO);
  return code ? { code, sujeto } : null;
}

export function setSesionLocal(code, sujeto) {
  sessionStorage.setItem(KEY_CODE,   code);
  sessionStorage.setItem(KEY_SUJETO, sujeto);
}

export function clearSesionLocal() {
  sessionStorage.removeItem(KEY_CODE);
  sessionStorage.removeItem(KEY_SUJETO);
}

/** Código del ensayo desde sesión o desde ?cod= de la URL. */
export function resolveEnsayoCode(codFromUrl = '') {
  const fromUrl = String(codFromUrl || '').trim().toUpperCase();
  if (fromUrl) return fromUrl;
  return getSesionLocal()?.code ?? null;
}

/** Tras terminar un test en ensayo, vuelve a /secuencias?cod=... */
export function navigateAfterTest(navigate, fallbackPath) {
  const code = resolveEnsayoCode(
    typeof window !== 'undefined'
      ? new URLSearchParams(window.location.search).get('cod') ?? ''
      : '',
  );
  if (code) {
    navigate(`/secuencias?cod=${encodeURIComponent(code)}`);
    return;
  }
  navigate(fallbackPath, { state: {} });
}
